/**
 * Helpers for TGMR-backed banner configs.
 *
 * Show rules:
 * - Case 1: TGMR ads found → show UI from those ads only
 * - Case 2: no ads, but feature config key exists → show copied/existing config
 * - Case 3: no ads and no config → hide UI
 */

export const hasConfigKeys = (rawConfig = {}, keyData = '') => {
	return Object.keys(rawConfig).some((key) => key.includes(keyData));
};

export const shouldShowTgmrBackedConfig = ({ hasAds = false, hasFeatureConfig = false }) => {
	return Boolean(hasAds || hasFeatureConfig);
};

export const getConfiguredIdsAsOptions = (ids = []) => {
	const validIds = ids.filter(Boolean);
	const uniqueIds = [...new Set(validIds)];
	return uniqueIds;
};
